import { Field, FieldProps } from 'formik';
import { ColorPicker } from '../ColorPicker/ColorPicker';

interface FormikColorPickerProps {
  name: string;
  label?: string;
  required?: boolean;
  disabled?: boolean | ((values: any) => boolean);
}

export const FormikColorPicker: React.FC<FormikColorPickerProps> = ({
  name,
  label,
  required,
  disabled,
}) => {
  return (
    <Field name={name}>
      {({ field, meta, form }: FieldProps) => {
        const isDisabled = typeof disabled === 'function'
          ? disabled(form.values)
          : disabled;

        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
          form.setFieldValue(name, e.target.value);
        };

        return (
          <ColorPicker
            name={name}
            value={field.value}
            label={label}
            disabled={isDisabled}
            required={required}
            onChange={handleChange}
            error={meta.touched && meta.error ? meta.error : ''}
          />
        );
      }}
    </Field>
  );
};
